import { CommonModule } from '@angular/common';
import { Injectable, NgModule, inject } from '@angular/core';
import {
  CORE_I18N_FOLDER,
  CORE_PAGE_MODULE,
  CorePageModule,
  CorePageModuleIDs,
  CoreSelectorGuard,
  CoreUtils,
  CoreUtilsService
} from '@bepatient/core';
import {
  QuizzActionLoadQuizz,
  selectorQuizzQuizz
} from '@bepatient/quizz-store';
import { IonicModule } from '@ionic/angular';
import { Store } from '@ngrx/store';
import { RightWrongPopupComponent } from './components/right-wrong-popup/right-wrong-popup.component';

@Injectable()
export class QuizzGuard extends CoreSelectorGuard {
  constructor() {
    const store = inject<Store<any>>(Store);

    super(store, selectorQuizzQuizz, new QuizzActionLoadQuizz());
  }
}
const quizzModule: CorePageModule = {
  ID: CorePageModuleIDs.QUIZZ,
  i18nLabel: 'MODULES.QUIZZ',
  icon: 'clock',
  leftMenuAvailableForDepthModules: true,
  routes: [
    ...CoreUtils.generateDepthModuleRoutes(
      'quizz',
      () =>
        import('./pages/quizz/quizz.module').then(
          module => module.QuizzPageModule
        ),
      QuizzGuard
    ),
    {
      path: 'quizz-results',
      loadChildren: () =>
        import('./pages/quizz-results/quizz-results.module').then(
          module => module.QuizzResultsPageModule
        )
    }
  ]
};

@NgModule({
  imports: [IonicModule, CommonModule],
  providers: [
    QuizzGuard,
    { provide: CORE_PAGE_MODULE, useValue: quizzModule, multi: true },
    { provide: CORE_I18N_FOLDER, useValue: './quizz/i18n/', multi: true }
  ],
  declarations: [RightWrongPopupComponent]
})
export class QuizzModule {
  constructor() {
    const coreUtilsService = inject(CoreUtilsService);

    coreUtilsService.addDepthModuleRoutes(quizzModule);
  }
}
